( ( { hooks: { addFilter: addFilterFe, applyFilters } }, { hooks: { doAction } } ) => {
  const MKTOFORM_ID_PREFIX = 'mktoForm_';
  const FOOTER_HOST_SELECTOR = '[data-berg-marketo-footer-form]';

  function getWrappers( config ) {
    const wrapperId = config.blockWrapperId;
    if ( !wrapperId ) return [];

    return Array.from( document.querySelectorAll( `[id="${CSS.escape( wrapperId )}"]` ) );
  }

  function getFormPlaceholder( config ) {
    const wrapper = getWrappers( config )[0] || null;
    if ( !wrapper ) return null;

    const parent = wrapper.parentElement;
    if ( !parent ) return null;

    const siblingForm = wrapper.previousElementSibling;
    if ( siblingForm?.tagName === 'FORM' ) {
      return siblingForm;
    }

    return parent.querySelector( ':scope > form' );
  }

  function ensureFooterFormHost( config ) {
    let footerHost = document.querySelector( FOOTER_HOST_SELECTOR );
    if ( footerHost ) {
      return footerHost;
    }

    const popup = document.getElementById( 'download-now' );
    const popupSection = popup?.querySelector( '.e-stn--cta-with-form' );
    if ( !popupSection || !popup?.parentNode ) {
      return null;
    }

    footerHost = popupSection.cloneNode( true );
    footerHost.setAttribute( 'data-berg-marketo-footer-form', 'true' );
    footerHost.querySelectorAll( 'form, .e-emf, script[src*="forms2"]' ).forEach( ( node ) => {
      node.remove();
    } );

    popup.parentNode.insertBefore( footerHost, popup );
    return footerHost;
  }

  function ensureFormPlaceholder( config ) {
    let wrapper = getWrappers( config )[0] || null;
    let formEl = getFormPlaceholder( config );

    if ( wrapper && formEl ) {
      return { wrapper, formEl };
    }

    const footerHost = ensureFooterFormHost( config );
    if ( !footerHost ) {
      return null;
    }

    const formContainer = footerHost.querySelector( '.e-col--right-column .e-div' )
      || footerHost.querySelector( '.e-div' );
    if ( !formContainer ) {
      return null;
    }

    formEl = document.createElement( 'form' );
    formEl.setAttribute( 'onsubmit', '_6si.send(event);' );

    wrapper = document.createElement( 'div' );
    wrapper.className = `e-emf e-emf--dlt e-emf-${config.embeddedFormId}`;
    wrapper.id = config.blockWrapperId;

    formContainer.appendChild( formEl );
    formContainer.appendChild( wrapper );

    return { wrapper, formEl };
  }

  function handleFormAction( config ) {
    const { responseType, redirectURL, downloadFileURL, linkOpenType, cookieValidity, popupVideo, popupVideoURL, popupVideoUploadURL, customVideoScript, defaultClass, embeddedFormId, currentPostId, isParentBlockGatedContentBlock, downloadButtonLabel } = config;

    if ( responseType === 'redirect' && redirectURL ) {
      window.open( redirectURL, linkOpenType );
    } else if ( responseType === 'download' && downloadFileURL ) {
      window.open( downloadFileURL, '_blank' );
    } else if ( responseType === 'redirectDownload' && redirectURL && downloadFileURL ) {
      window.open( downloadFileURL, '_blank' );
      window.open( redirectURL, linkOpenType );
    } else if ( responseType === 'resource-same-page' ) {
      if ( isParentBlockGatedContentBlock ) {
        const expires = new Date();
        expires.setTime( expires.getTime() + ( 24 * cookieValidity * 60 * 60 * 1000 ) );
        document.cookie = `postId_${currentPostId}=true; expires=${expires.toUTCString()}; path=/`;
      }
      setTimeout( () => window.location.reload( true ), 1000 );
    } else if ( responseType === 'popup' ) {
      if (
        ( popupVideo === 'url' && popupVideoURL )
        || ( popupVideo === 'upload' && popupVideoUploadURL )
        || ( popupVideo === 'embedded' && customVideoScript )
      ) {
        document.getElementById( `${defaultClass}_fancybox_${embeddedFormId}` )?.click();
      }
    } else if ( responseType === 'thankYouDownloadCta' ) {
      const cookieName = `hs_form_${currentPostId}`;
      const expires = new Date();
      expires.setTime( expires.getTime() + 600000 );
      document.cookie = `${cookieName}=true;expires=${expires.toUTCString()}; path=/`;
      const label = downloadButtonLabel?.trim() || '';
      window.open(
        `${redirectURL}?file=${btoa( downloadFileURL )}&postId=${btoa( currentPostId )}&label=${encodeURIComponent( label )}`,
        '_self'
      );
    }
  }

  function handleFormResponse( config ) {
    const { responseMessage, embeddedFormId, formId } = config;
    const formEl = document.querySelector( `[data-embedded-form-id="${embeddedFormId}"]` )
      || document.getElementById( `${MKTOFORM_ID_PREFIX}${formId}` );

    if ( responseMessage && formEl ) {
      formEl.innerHTML = responseMessage;
    }

    handleFormAction( config );
  }

  function stashMarketoLeadValues( values ) {
    if ( ! values || typeof values !== 'object' ) {
      return;
    }

    try {
      // Preserve Marketo's submitted field map (Email, FirstName, etc.) for the thank-you page.
      window.sessionStorage.setItem( 'ironclad_mkto_lead', JSON.stringify( values ) );
    } catch ( e ) {
      // Ignore quota / private-mode failures; ChiliPiper handoff is best-effort.
    }
  }

  function attachSuccessHandler( form, config ) {
    form.onSuccess( ( values, followUpUrl ) => {
      stashMarketoLeadValues( values );
      doAction( 'b3rg_embedded_form_marketo_form_load_event', config, form, followUpUrl );

      const hasFollowUp = typeof followUpUrl === 'string' && followUpUrl.trim() !== '';

      if ( config.responseType === 'original' && hasFollowUp ) {
        window.location.href = followUpUrl;
      } else {
        const handler = applyFilters(
          'b3rg_embedded_form_marketo_form_load_handler',
          handleFormResponse,
          config
        );
        handler( config );
      }

      return false;
    } );
  }

  const IP_API_URL = 'https://ipapi.co/json/?key=c5CTtYsq6TOebWvtSFkb0nsoNPUnkTMjQdUKwK3Az3m9FXHXg9';

  function getVisitorCountry() {
    if ( typeof window.__ironcladGetVisitorCountry === 'function' ) {
      return window.__ironcladGetVisitorCountry();
    }
    if ( !window.__ironcladVisitorCountryPromise ) {
      window.__ironcladVisitorCountryPromise = fetch( IP_API_URL )
        .then( ( response ) => {
          if ( !response.ok ) {
            throw new Error( 'IP API returned ' + response.status );
          }
          return response.json();
        } )
        .then( ( data ) => data.country || '' )
        .catch( ( error ) => {
          console.error( 'Error fetching geolocation from ipapi:', error );
          return '';
        } );
    }
    return window.__ironcladVisitorCountryPromise;
  }

  function applyIpinfoCountryToForm( form, country ) {
    if ( typeof window.__ironcladApplyIpinfoCountryToForm === 'function' ) {
      window.__ironcladApplyIpinfoCountryToForm( form, country );
      return;
    }
    if ( form && country && typeof form.setValues === 'function' ) {
      form.setValues( { ipinfoCountry: country } );
    }
  }

  function formElementForWrapper( wrapper ) {
    const parent = wrapper?.parentElement;
    if ( !parent ) return null;

    const siblingForm = wrapper.previousElementSibling;
    if ( siblingForm?.tagName === 'FORM' ) {
      return siblingForm;
    }

    return parent.querySelector( ':scope > form' );
  }

  function clearMarketoFormIds( formId ) {
    const targetId = `${MKTOFORM_ID_PREFIX}${formId}`;
    document.querySelectorAll( 'form' ).forEach( ( formEl ) => {
      if ( formEl.id === targetId ) {
        formEl.removeAttribute( 'id' );
      }
    } );
  }

  function collectFormHosts( configs ) {
    const hosts = [];
    const seenForms = new Set();

    configs.forEach( ( config ) => {
      const wrappers = getWrappers( config );
      wrappers.forEach( ( wrapper ) => {
        const formEl = formElementForWrapper( wrapper );
        if ( !formEl || seenForms.has( formEl ) ) return;
        seenForms.add( formEl );
        hosts.push( { config, formEl } );
      } );

      if ( wrappers.length ) return;

      const placeholder = ensureFormPlaceholder( config );
      if ( !placeholder || seenForms.has( placeholder.formEl ) ) return;
      seenForms.add( placeholder.formEl );
      hosts.push( { config, formEl: placeholder.formEl } );
    } );

    return hosts;
  }

  function loadFormInstances( configs ) {
    const formId = configs[0].formId;
    const { marketoBaseUrl, munchkinId } = configs[0];
    const instances = collectFormHosts( configs );

    if ( !instances.length || typeof window.MktoForms2 === 'undefined' ) {
      return;
    }

    // Match demo-sidepop: set ipinfoCountry in loadForm callback so visibility
    // rules (Email_Opt_In__c) evaluate with country present — late whenReady
    // setValues will not re-hide a checkbox that already painted.
    getVisitorCountry().then( ( country ) => {
      ( function loadNext( index ) {
        const instance = instances[index];
        if ( !instance ) return;

        const { config, formEl } = instance;
        clearMarketoFormIds( formId );
        formEl.setAttribute( 'data-formId', formId );
        formEl.setAttribute( 'data-embedded-form-id', config.embeddedFormId );
        formEl.classList.add( 'mktoForm' );
        formEl.id = `${MKTOFORM_ID_PREFIX}${formId}`;

        window.MktoForms2.loadForm( marketoBaseUrl, munchkinId, formId, ( form ) => {
          applyIpinfoCountryToForm( form, country );
          attachSuccessHandler( form, config );
          formEl.removeAttribute( 'id' );
          loadNext( index + 1 );
        } );
      } )( 0 );
    } );
  }

  function initMultiInstanceForms( configs ) {
    const configsByFormId = configs.reduce( ( groups, config ) => {
      ( groups[config.formId] ||= [] ).push( config );
      return groups;
    }, {} );

    Object.values( configsByFormId ).forEach( loadFormInstances );
  }

  addFilterFe(
    'b3rg_embedded_form_marketo_event_binder',
    'b3rg/embedded-forms',
    () => {
      const pendingConfigs = [];
      let scheduled = false;

      return ( config ) => {
        pendingConfigs.push( config );

        if ( scheduled ) return;
        scheduled = true;

        queueMicrotask( () => {
          scheduled = false;
          initMultiInstanceForms( pendingConfigs.splice( 0 ) );
        } );
      };
    }
  );
} )( feWp, wp ); // eslint-disable-line no-undef
